import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LandingGemComponent } from '../landing-gem/landing-gem.component';

@Component({
  selector: 'campaign-landing-loader',
  imports: [LandingGemComponent],
  templateUrl: './landing-loader.component.html',
  styleUrl: './landing-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingLoaderComponent {}
